export enum BalanceQueryKeys {
  Transactions = "balance.transactions",
  TransactionsPaginated = "balance.transactions.paginated",
}
